import {
  RegisterNetworkData,
  Director,
  Address,
} from 'components/NetworkRegister/NetworkRegisterInterface/NetworkRegisterInterface';

const mapDirectors = (directors: Director[]) =>
  directors.map((director: Director) => ({
    title: director.title,
    first_name: director.firstName,
    middle_name: director.middleName,
    surname: director.surname,
    date_of_birth: director.dateOfBirth,
    gender: director.gender,
    addresses: director.addresses.map((address: Address) => ({
      post_code: address.postCode.toString().toUpperCase(),
      house_number: address.houseNr,
      street_line_1: address.line1,
      street_line_2: address.line2 || '',
      city: address.city,
      county: address.county,
      resident_from_date: address.residentFrom,
    })),
  }));

const mapNetworkValues = ({
  fcaNumber,
  networkName,
  postCode,
  houseNr,
  line1,
  line2,
  city,
  county,
  email,
  phoneNumber,
  commissionTerms,
  sortCode,
  accNumber,
  accName,
  directors,
  submissionRoute,
}: RegisterNetworkData) => {
  return {
    fca_number: fcaNumber,
    name: networkName,
    post_code: postCode.toUpperCase(),
    house_number: houseNr,
    street_line_1: line1,
    street_line_2: line2,
    city,
    county,
    email,
    phone_number: phoneNumber,
    commission_term_id: commissionTerms && submissionRoute === 'Direct' ? commissionTerms : null,
    submission_route: submissionRoute && submissionRoute === 'Direct' ? null : submissionRoute,
    account_sort_code: sortCode,
    account_number: accNumber,
    account_name: accName,
    directors: mapDirectors(directors),
  };
};

export default mapNetworkValues;
